module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6n7n9r3r-5b012246de7deb1d6de091c8d67c637c.svg";